export default __webpack_public_path__ + "static/media/Project08.eb33c46c.jpg";